
export interface AdvanceShareStyleAssetDefinition {
    key?: string;
    type?: AdvanceShareStyleAssetTypeEnum;
    required?: boolean;
}
export enum AdvanceShareStyleAssetTypeEnum
{
    UserImage = 1,
    GearImage = 2,
    RouteImage = 3,
    AppLogo = 4,
    AppLogoWithText = 5,
}
export const AdvanceShareStyleAssetTypeList = 
[
    { value: 1, label: "User Image" },
    { value: 2, label: "Gear Image" },
    { value: 3, label: "Route Image" },
    { value: 4, label: "App Logo" },
    { value: 5, label: "App Logo With Text" },
];

export interface AdvanceShareStyleVariableDefinition {
    key?: string;
    type?: AdvanceShareStyleVariableTypeEnum;
    required?: boolean;
}
export enum AdvanceShareStyleVariableTypeEnum
{
    CustomVariable = 1,
    ActivityDistance = 2,
    ActivityTime = 3,
    ActivityPace = 4,
    CustomText = 5,
    // Runner DNA collectible-card background. The app sends a short key
    // (holo, burst, prism, galaxy, deco, frame); the API swaps it for the full
    // background description. Unknown or missing keys fall back to holo.
    RunDnaCardBackground = 6,
}
export const AdvanceShareStyleVariableTypeList = 
[
    { value: 1, label: "Custom Variable" },
    { value: 2, label: "Activity Distance" },
    { value: 3, label: "Activity Time" },
    { value: 4, label: "Activity Pace" },
    // Backed by ExtraTextVariableProvider, which reads the request's ExtraText.
    { value: 5, label: "Custom Text" },
    { value: 6, label: "Run DNA Card Background" },
];

export interface AdvanceShareStylePolicyDefinition {
    type?: AdvanceShareStylePolicyTypeEnum;
}
export enum AdvanceShareStylePolicyTypeEnum
{
    PremiumUser = 1,
    // The API defines PremiumUserWithFreeTry = 2, but ships no handler for it —
    // PremiumUserPolicyHandler is the only registered handler and it supports
    // PremiumUser alone. Selecting 2 would resolve to nothing and fail the
    // generation at PolicyStep, so it is deliberately not offered here until a
    // handler exists.
}
export const AdvanceShareStylePolicyTypeList = 
[
    { value: 1, label: "Premium User" },
];


export interface AdvanceShareStyleRenderingConfigDefinition {
    defaultAspectRatio?: AdvanceShareStyleAiAspectRatioEnum;
    preferredAiProvider?: AdvanceShareStyleAiProviderEnum;
}

export enum AdvanceShareStyleAiAspectRatioEnum
{
    One_One = 1,
    Two_Three = 2,
    Three_Two = 3,
    Three_Four = 4,
    Four_Three = 5,
    Four_Five = 6,
    Five_Four = 7,
    Nine_Sixteen = 8,
    Sixteen_Nine = 9,
    TwentyOne_Nine = 10  
}
export const AdvanceShareStyleAiAspectRatioList = 
[
    { value: 1, label: "1:1" },
    { value: 2, label: "2:3" },
    { value: 3, label: "3:2" },
    { value: 4, label: "3:4" },
    { value: 5, label: "4:3" },
    { value: 6, label: "4:5" },
    { value: 7, label: "5:4" },
    { value: 8, label: "9:16" },
    { value: 9, label: "16:9" },
    { value: 10, label: "21:9" },
];

export enum AdvanceShareStyleAiProviderEnum
{
    Gemini = 1,
}
export const AdvanceShareStyleAiProviderList = 
[
    { value: 1, label: "Gemini" },
];


export interface AdvanceShareStyleUsageRuleDefinition {
    audience?: AdvanceShareStyleUsageAudienceTypeEnum,
    period?: AdvanceShareStyleUsagePeriodTypeEnum,
    limit?: number,
    priority?: number,
}

export enum AdvanceShareStyleUsageAudienceTypeEnum
{
    Free = 1,
    Premium = 2,
}
export const AdvanceShareStyleUsageAudienceTypeList = 
[
    { value: 1, label: "Free" },
    { value: 2, label: "Premium" },
];

export enum AdvanceShareStyleUsagePeriodTypeEnum
{
    Lifetime = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
    Yearly = 5,
}
export const AdvanceShareStyleUsagePeriodTypeList = 
[
    { value: 1, label: "Lifetime" },
    { value: 2, label: "Daily" },
    { value: 3, label: "Weekly" },
    { value: 4, label: "Monthly" },
    { value: 5, label: "Yearly" },
];

